import React, { useEffect } from "react";

import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import COAVolumes from "./coa/coaVolumes";

import { Alerts } from "./alerts/alerts";
import { Constraints } from "./constraints/constraints";
import { Operations } from "./operations/operations";

import { useNavigate } from "react-router";
import { useUserAuth } from "../contexts/authContext";
import { useLocalStorage } from "../hooks/useLocalStorage";

export function Manager() {
    const [tab, setTab] = useLocalStorage("userManagerTab", "1");
    const { user } = useUserAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (user.user_role === "First Responder") navigate("/map");
    }, []);

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <Box sx={{ width: "100%", height: "100%", p: 1, display: "flex", flexDirection: "column", gap: 1, overflowY: "auto" }}>
            <Typography
                component="h2"
                variant="h6"
                color="#6b778c"
                noWrap
                sx={{ flexShrink: 0, p: 2, pb: "0px !important", display: { xs: "none", sm: "block" } }}
            >
                Airspace Manager
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                <TabContext value={tab}>
                    <Paper sx={{ p: { xs: 0, sm: 2 }, pb: "0px !important", borderBottomRightRadius: 0, borderBottomLeftRadius: 0 }}>
                        <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
                            <Tab label="Operations" value="1" id="operations" />
                            <Tab label="Constraints" value="2" id="constraints" />
                            <Tab label="Alert Volumes" value="3" id="alertVolumes" />
                            <Tab label="COA Volumes" value="4" id="coaVolumes" />
                        </Tabs>

                        <Divider />
                    </Paper>

                    {/* Operations Manager */}
                    <TabPanel sx={{ p: 0, height: "100%" }} value="1">
                        <Operations />
                    </TabPanel>

                    {/* Constraints Manager */}
                    <TabPanel sx={{ p: 0, height: "100%" }} value="2">
                        <Constraints />
                    </TabPanel>

                    {/* Alert Volumes Manager */}
                    <TabPanel sx={{ p: 0, height: "100%" }} value="3">
                        <Alerts />
                    </TabPanel>

                    {/* COA Volumes Manager */}
                    <TabPanel sx={{ p: 0, height: "100%" }} value="4">
                        <COAVolumes />
                    </TabPanel>
                </TabContext>
            </Box>
        </Box>
    );
}
